<div
  class="scorecard scorecard-locked rounded scorecard-container"
  (click)="openScorecardDescription()"
  [ngClass]="{ 'scorecard-linked-shadow': scorecard?.ParentId || isScorecardHasChild }"
>
  <!--Header-->
  <div class="scorecard-locked-header">
    <img
      alt=""
      class="scorecard-locked-image"
      src="{{ scorecard?.Image | contentImage: '7' : 'badge' }}"
      [useDefault]="true"
      [loyaltyType]="'badge'"
    />
    <h3 class="scorecard-name">
      {{ scorecard?.Content[0].Name }}
    </h3>
    <div class="scorecard-description">
      {{ 'scorecard.modal.locked.description' | translate: { parentScorecardName: parentScorecard?.Content[0].Name } }}
    </div>
  </div>
  <div class="scorecard-locked-footer">
    <i class="material-icons lock-icon">lock</i>
    <span class="scorecard-locked-text">{{ 'scorecard.modal.locked.title' | translate }}</span>
  </div>
</div>
